<template>
  <el-date-picker
    :value="dateFrom"
    v-bind="$attrs"
    type="datetime"
    format="dd/MM/yy HH:mm"
    value-format="timestamp"
    placeholder="Selecciona fecha y hora"
    :picker-options="optionsPicker"
    v-on="$listeners"
    @focus="onFocus"
    @change="onChangeDatePickerFrom"
  />
</template>

<script>
export default {
  name: "DatePickerFromFuture",

  inheritAttrs: false,

  props: {
    value: Number,
  },

  data() {
    return {
      dateFrom: null,
      optionsPicker: {
        disabledDate(time) {
          let d = new Date();
          var yesterday = new Date(d);
          yesterday.setDate(yesterday.getDate() - 1);
          return time.getTime() < yesterday;
        },
      },
    };
  },

  watch: {
    value(newValue) {
      this.dateFrom = newValue;
    },
  },

  methods: {
    onFocus() {
      if (!this.dateFrom) {
        this.dateFrom = new Date().getTime();
      }
    },

    onChangeDatePickerFrom() {
      let nowInSeconds = Math.floor(new Date().getTime() / 1000);
      if (this.dateFrom !== null && this.dateFrom / 1000 < nowInSeconds) {
        this.dateFrom = new Date().getTime();
        this.$message({
          type: "info",
          message:
            "La fecha no puede ser anterior a la fecha y hora actual, se ha actualizado a fecha y hora actual",
        });
      }
      this.$emit("change-date-picker");
    },
  },
};
</script>
